import React, { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom';
import { Input, Label, Button, Card, CardBody, CardTitle, Col, Nav, NavItem, NavLink, Row, Table, Badge, Modal, ModalHeader, ModalBody } from 'reactstrap';
import Skeleton from "react-loading-skeleton";
import Image from '../../components/Image'
import dummyRoundedImage from "../../assets/images/dummy-rounded-image.png"
import { campaignStatus, getAllAgents, getCampaigns, updateAgentStatus } from '../../helper/backend-methods';
import { showToast } from '../../components/Toast';
import moment from 'moment';
import { formatTimeFromSeconds, formatDate } from '../../helper/format';
import { EmptyRow } from '../../components/EmptyState';
import { compressToEncodedURIComponent } from "lz-string";
import { useHorizontalScrollShadow } from '../../hooks/useHorizontalScrollShadow';

const ListCampaigns = () => {
    const { scrollRef, isScrolled } = useHorizontalScrollShadow();
    const [loading, setLoading] = useState(false);
    const [campaigns, setCampaigns] = useState([]);
    const [update, setUpdate] = useState(0);
    const [selectedCampaign, setSelectedCampaign] = useState({})
    const [viewModal, setViewModal] = useState(false);
    const [mode, setMode] = useState(false);
    const [keyword, setKeyword] = useState("");
    const keywordRef = useRef("");

    useEffect(() => {
        getCampaignsList();
    }, [update])

    const getCampaignsList = (limit = 30, offset = 0, keyword = "") => {
        setLoading(true)
        setCampaigns([])
        getCampaigns({ ...(keyword && keyword.length && { search: keyword }) }).then((data) => {
            console.log(data)
            if (data.data) {
                setCampaigns(data.data ? data.data : [])
            }
            else {
                showToast("error", "Request Failed", data.message)
            }
            setLoading(false)
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
        })
    }

    const searchByKeyword = (e) => {
        e.preventDefault();
        setKeyword(keywordRef.current.value);
        getCampaignsList(30, 0, keywordRef.current.value)
    }

    const handleViewModal = (mode, campaign) => {
        setSelectedCampaign(campaign)
        setMode(mode)
        setViewModal(true)
    }

    const changeCampaignStatus = (id, status) => {
        campaignStatus({ _id: id, isActive: status }).then((data) => {
            if (data) {
                setUpdate(prev => prev + 1)
            }
            else {
                showToast("error", "Request Failed", data.message)
            }
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
        })
    }

    return (
        <div className="content-page">
            <div className="content">

                <div className="container-fluid">

                    <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column">
                        <div className="flex-grow-1">

                            <Row className="my-2 align-items-center">
                                <Col md={8}>
                                    <h4>Campaign Management</h4>
                                    <p className='text-muted fs-12'>Manage and monitor your campaigns</p>
                                </Col>
                                <Col md={4} className='text-right'>
                                    <Link to={"/create-new-campaign"} className="font-normal py-2 px-4 rounded fs-16 text-decoration-none text-white linear-gradient-btn"><i className="ri-add-line"></i> Create New Campaign</Link>
                                </Col>
                            </Row>
                            <Row className='mb-4'>
                                <Col md={5}>
                                    <form className="">
                                        <div className='d-flex'>
                                            <div className="position-relative w-70 me-2">
                                                <input type="text" className="form-control p-2 ps-4" placeholder="Search..." ref={keywordRef} />
                                                <i className="ri-search-line fs-16 position-absolute text-muted top-50 translate-middle-y ms-2"></i>
                                            </div>
                                            <Button type='submit' disabled={loading} onClick={(e) => { searchByKeyword(e) }} className="font-normal py-2 px-4 rounded fs-14 linear-gradient-btn">Search</Button>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className={`table-responsive${isScrolled ? ' is-scrolled' : ''}`} ref={scrollRef}>
                                    <Table hover className='border-rounded custom-listing-tables table-cols-campaigns table-sticky-first'>
                                        <thead>
                                            <tr>
                                                <th>Campaign</th>
                                                <th>Description</th>
                                                <th>Agent</th>
                                                <th>Calls Made</th>
                                                <th>Converted</th>
                                                <th>Status</th>
                                                <th>Active</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Time (UTC)</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                loading ?
                                                    [...Array(30)].map((a, i) => {
                                                        return <tr key={i}>
                                                            <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                            <td className="fs-12"><div className='d-flex align-items-center'><Skeleton height={40} width={40} circle={true} className='me-2' /><Skeleton height={12} width={90} /></div></td>
                                                            <td className="fs-12"><Skeleton height={12} width={90} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={60} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={60} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={60} /></td>
                                                            <td className="fs-12" colSpan={2}><Skeleton height={12} width={40} /></td>
                                                        </tr>
                                                    }) :
                                                    campaigns.length === 0 ?
                                                        <EmptyRow colSpan={11} icon="ri-megaphone-line" title="No campaigns yet" body="Launch a campaign to start reaching your contacts." /> :
                                                        campaigns.map((campaign, i) => {
                                                            return <tr key={i}>

                                                                <td className="fs-12 fw-500">{campaign.name}</td>
                                                                <td className="fs-12 fw-500"><p className='text-decoration-underline m-0 cursor-pointer' onClick={() => { handleViewModal('description', campaign) }}>View Description</p></td>
                                                                <td className="fs-12 fw-500"><div className='d-flex align-items-center'><Image src={dummyRoundedImage} alt="Event" className='rounded-circle me-2' height='28px' width='28px' objectFit='cover' /><p className='m-0'>{campaign.agentId.name} <span className=' d-block text-muted fs-12 text-capitalize'>{campaign.agentId.type}</span></p></div></td>
                                                                <td className="fs-12 fw-500">{campaign.totalCallsMade}</td>
                                                                <td className="fs-12 fw-500">{campaign.totalCallsConverted}</td>
                                                                <td className="fs-12 fw-500">{campaign.campaignStatus === "RUNNING" || campaign.campaignStatus === "COMPLETED" ? <Badge color='badge-success badge-soft-success fs-12 text-capitalize'>{campaign.campaignStatus}</Badge> : campaign.campaignStatus === "SCHEDULED" || campaign.campaignStatus === "PAUSED" ? <Badge color='badge-warning badge-soft-warning fs-12 text-capitalize'>{campaign.campaignStatus}</Badge> : <Badge color='badge-danger badge-soft-danger fs-12 text-capitalize'>{campaign.campaignStatus}</Badge>}</td>
                                                                <td className="fs-20 fw-500"><div className="form-check form-switch gradient-switch" dir="ltr"><input role='switch' type="checkbox" checked={campaign.isActive} onChange={(e) => { changeCampaignStatus(campaign._id, !campaign.isActive); }} className="form-check-input" /></div></td>
                                                                <td className="fs-12 fw-500 text-nowrap">{formatDate(campaign.startDate)}</td>
                                                                <td className="fs-12 fw-500 text-nowrap">{formatDate(campaign.endDate)}</td>
                                                                <td className="fs-12 fw-500">{moment(campaign.preferredTime.from, "HH:mm").format("hh:mm A")} to {moment(campaign.preferredTime.to, "HH:mm").format("hh:mm A")}</td>
                                                                <td>
                                                                    {moment().isBefore(moment(campaign.startDate)) ? <Link className='fs-20 fw-500' to={"/update-campaign/" + campaign._id + "?data=" + compressToEncodedURIComponent(JSON.stringify(campaign.customFields)) + "&campaign_info=" + compressToEncodedURIComponent(JSON.stringify({ title: campaign.name, description: campaign.description, startDate: campaign.startDate, endDate: campaign.endDate, startTime: campaign.preferredTime.from, endTime: campaign.preferredTime.to }))} state={campaign}><i className="ri-edit-box-line cursor-pointer" ></i></Link> : <i className="ri-edit-box-line cursor-pointer fs-20" ></i>} 
                                                                    <Link className='fs-20 fw-500' to={"/duplicate-campaign/" + "?data=" + compressToEncodedURIComponent(JSON.stringify(campaign.customFields)) + "&campaign_info=" + compressToEncodedURIComponent(JSON.stringify({ title: campaign.name, description: campaign.description, startDate: campaign.startDate, endDate: campaign.endDate, startTime: campaign.preferredTime.from, endTime: campaign.preferredTime.to }))} state={campaign}><i className="ri-file-copy-line cursor-pointer" ></i></Link>
                                                                    </td>
                                                            </tr>
                                                        })

                                            }
                                        </tbody>
                                    </Table>
                                    </div>
                                    <Modal isOpen={viewModal} toggle={() => { setViewModal(false) }} centered={true} size='lg'>
                                        <ModalHeader toggle={() => { setViewModal(false) }}>
                                            <small>{mode === 'description' ? "Campaign Description" : "Discription"}</small>
                                        </ModalHeader>
                                        <ModalBody>
                                            <Row>
                                                {
                                                    mode === "description" ?
                                                        <Col md={12} className='mb-4'>
                                                            <textarea disabled={true} value={mode === 'description' ? selectedCampaign.description : ""} className='fs-16 rounded p-2 custom-textarea' ></textarea>
                                                        </Col> : null
                                                }
                                            </Row>
                                            <Row className="text-center mt-3">
                                                <Col>
                                                    <button className="btn btn-outline-primary mr-2" onClick={() => { setViewModal(false) }}>Close</button>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                    </Modal>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListCampaigns
